<div class="session-timeout-modal">
  <div class="modal-header">
    <h2 mat-dialog-title>Session Expiring Soon</h2>
  </div>

  <mat-dialog-content class="modal-content">
    <div class="warning-icon">
      <i class="fas fa-exclamation-triangle"></i>
    </div>

    <p class="warning-message">
      Your session is about to expire due to inactivity.
    </p>

    <div class="countdown-display">
      <span class="countdown-label">Time remaining:</span>
      <span class="countdown-timer">{{ getFormattedCountdown() }}</span>
    </div>

    <p class="info-message">
      You will be automatically logged out if no action is taken.
    </p>
  </mat-dialog-content>

  <mat-dialog-actions class="modal-actions">
    <button mat-button class="btn-logout" (click)="logout()">
      Logout Now
    </button>
    <button mat-raised-button color="primary" class="btn-continue" (click)="continueSession()">
      Continue Session
    </button>
  </mat-dialog-actions>
</div>
